export enum CameraEventEnum {
    VEHICLE_INTEGRATION = 'VEHICLE_INTEGRATION',
    VEHICLE_LEAVE = 'VEHICLE_LEAVE',
    CAMERA_STATUS_CHANGE = 'CAMERA_STATUS_CHANGE',
    CAMERA_NAME_CHANGE = 'CAMERA_NAME_CHANGE',
    CAMERA_UNPAIR = 'CAMERA_UNPAIR',
    CAMERA_PAIR = 'CAMERA_PAIR',
    TV_BACKGROUND_UPDATE = 'TV_BACKGROUND_UPDATE',
    TV_DISPLAY_MODE_UPDATE = 'TV_DISPLAY_MODE_UPDATE',
}
